import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { XLogo } from ".";
export const TwitterLogo = React.forwardRef((props, ref) => (_jsx(XLogo, { ref: ref, ...props, "data-testid": "TwitterLogo" })));
TwitterLogo.displayName = "TwitterLogo";
